import React from "react";
import PropTypes from "prop-types";

const InputSwitch = (props) => {
  const { title = "", checked, onChange, disabled = false, error = {} } = props;

  const _onChange = (e) => {
    if (onChange) {
      onChange(e.target.checked);
    }
  };

  return (
    <div className="flex items-center gap-3">
      {title && (
        <label className="text-sm font-medium text-gray-700">
          {title}
        </label>
      )}

      <label className="relative inline-flex items-center cursor-pointer">
        <input
          type="checkbox"
          checked={checked}
          onChange={_onChange}
          disabled={disabled}
          className="sr-only peer"
        />
        <div
          className={`
          w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 
          peer-focus:ring-blue-300 rounded-full peer 
          peer-checked:after:translate-x-full peer-checked:after:border-white 
          after:content-[''] after:absolute after:top-[2px] after:left-[2px] 
          after:bg-white after:border-gray-300 after:border after:rounded-full 
          after:h-5 after:w-5 after:transition-all 
          peer-checked:bg-blue-600
          ${disabled ? "opacity-50 cursor-not-allowed" : ""}
        `}
        ></div>
      </label>

      {error?.message && (
        <span className="text-sm text-red-600">{error.message}</span>
      )}
    </div>
  );
};

InputSwitch.propTypes = {
  title: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  error: PropTypes.object,
};

export default InputSwitch;
